




















import Card from "@/components/UI/Card.vue";
import LocalData from "@/mixins/local-data";
import {Component, Mixins} from "vue-property-decorator";
import Http from '../mixins/http';
import Toast from '../mixins/toast';
import MarketSelect from "@/components/MarketSelect.vue";
import Modal from "@/components/UI/Modal.vue";
import SalePointsDirectory from "@/components/SalePointsDirectory.vue";
import AssortmentDirectory from "@/components/AssortmentDirectory.vue";
import ProductLineDirectory from "@/components/ProductLineDirectory.vue";
import {hasPermission} from "@/utils/hasPermission";

@Component({
  components: {
    AssortmentDirectory,
    SalePointsDirectory,
    ProductLineDirectory,
    Modal,
    MarketSelect,
    Card
  },
})
export default class MasterData extends Mixins(Http, Toast, LocalData) {
  currentMainTab: string = "salePointsDirectory"

  get hasProductLineDirectoryAccess(): boolean {
    return hasPermission('UPLOADS_DIRECTORIES');
  }

  tabClick(key: string) {
    this.currentMainTab = key
  }
}
